import React from 'react';
import { PartyModalMessages } from './PartyModalMessages';
import { useApplicationContext } from '../../../../../../state';
import { DeletePartyModal } from './DeletePartyModal';
import { PartyRowContainer } from '../PartyRowContainer';

// controls PartyModals
export const PartyModalsContainer: React.FC = () => {
  const [{ partyModals }] = useApplicationContext();

  return (
    <>
      {partyModals?.modalMessage && <PartyModalMessages {...partyModals.modalMessage} />}
      {partyModals.deletingParty && <DeletePartyModal party={partyModals.deletingParty} />}
      {partyModals.addingParty && (
        <PartyRowContainer party={partyModals.addingParty} data-test-id={`party-add`} isNew />
      )}
    </>
  );
};
